import { FC } from "react";
import { useLocation } from "react-router-dom";
import { MainContentView } from "./MainContentView";
import { MainInitView } from "./MainInitView";
import { MainRoutes } from "./MainRoutes";

export const MainPathView: FC = () => {
  const { pathname } = useLocation();
  const isHomePage = pathname === "/";
  const isRedirectingPage = pathname === "/redirecting";

  // We don't create user sessions on the home page
  if (isHomePage || isRedirectingPage) {
    return <MainRoutes />;
  }

  return (
    <>
      <MainInitView />
      <MainContentView />
    </>
  );
};
